if (!customElements.get('tabs-list')) {
  class TabsList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        tabs: this.querySelectorAll('[role="tab"]'),
        tabPanels: this.querySelectorAll('[role="tabpanel"]'),
      };

      this.addEvents();
    }

    addEvents = () => {
      for (const tab of this.elements.tabs) {
        tab.addEventListener('click', this.onClick);
      }
    }

    onClick = (event) => {
      for (let index = 0; index < this.elements.tabs.length; index++) {
        const panel = this.elements.tabPanels[index];
        if (panel?.getAttribute('aria-labelledby') === event.target.getAttribute('id')) {
          panel.classList.add('is-active');
        } else {
          panel?.classList.remove('is-active');
        }

        const tab = this.elements.tabs[index];
        if (tab === event.target) {
          tab.setAttribute('aria-selected', 'true');
        } else {
          tab?.removeAttribute('aria-selected');
        }
      }
    }
  }
  customElements.define('tabs-list', TabsList);
}
